import { Link, useParams } from 'react-router-dom';
import { ca } from '../i18n/ca';
import { useAuth } from './AuthContext';
import { PlacementReport } from './PlacementReport';
import { SessionTests } from './SessionTests';
import { Shell } from './Shell';
import { placementReportOf, useSessionLive } from './useSessionLive';

/**
 * What the platform knows about a session from the inside
 * ({@code /s/:code/tecnic}, an admin's): the runtime's placement report and
 * the merged timeline the agent reads. Both stood on the session page
 * itself, which a player opens to join a night, until the owner asked for
 * them to be out of it (2026-09-29). Nothing here is new: the two sections
 * moved, and the door narrowed from "whoever directs" and "anybody signed in"
 * to an admin.
 */
export function SessionTechnical() {
  const { code = '' } = useParams<{ code: string }>();
  const t = ca.sessionTechnical;
  const { me } = useAuth();
  const isAdmin = me.roles.includes('ADMIN');

  return (
    <Shell title={t.title(code)} width="wide">
      <p>
        <Link to={`/s/${code}`}>← {t.back}</Link>
      </p>
      {isAdmin ? <Technical code={code} /> : <p className="muted">{t.adminOnly}</p>}
    </Shell>
  );
}

/** Apart, so nothing is asked of the platform for somebody the page is not for. */
function Technical({ code }: { code: string }) {
  const t = ca.sessionTechnical;
  const { events, error } = useSessionLive(code, 'direction');
  return (
    <>
      <p className="muted">{t.intro}</p>
      {error && (
        <p className="error" role="alert">
          {error}
        </p>
      )}
      <section className="cards">
        <PlacementReport report={placementReportOf(events)} />
      </section>
      <section className="cards">
        <SessionTests code={code} />
      </section>
    </>
  );
}
